<template>
  <div id="PrefabCreator" ref="target" v-click-outside="onClickOutsideHandler">
    <div class="PCHeader">
      <div class="PCHeader_nav">
        <div class="PrefabLogo">
          <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M26.25 8.5776V19.4206C26.2501 19.5456 26.2143 19.6683 26.1464 19.776C26.0784 19.8837 25.9809 19.9725 25.8637 20.0331L15.3638 25.4768C15.2524 25.5344 15.1273 25.5646 15 25.5646C14.8727 25.5646 14.7476 25.5344 14.6362 25.4768L4.13625 20.0331C4.01915 19.9725 3.92157 19.8837 3.85364 19.776C3.78572 19.6683 3.74994 19.5456 3.75 19.4206V8.5776C3.75016 8.45282 3.78605 8.33034 3.85396 8.22286C3.92187 8.11537 4.01933 8.02679 4.13625 7.96627L14.6362 2.52143C14.7476 2.46382 14.8727 2.43359 15 2.43359C15.1273 2.43359 15.2524 2.46382 15.3638 2.52143L25.8637 7.96627C25.9807 8.02679 26.0781 8.11537 26.146 8.22286C26.214 8.33034 26.2498 8.45282 26.25 8.5776Z"
                stroke="#061B3A" stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M4.41016 8.5089L14.6352 13.8102C14.7466 13.8681 14.872 13.8984 14.9995 13.8984C15.127 13.8984 15.2525 13.8681 15.3639 13.8102L25.6252 8.49023M15.0002 24.4992V13.9992"
                stroke="#061B3A" stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M14.6138 13.7985L4.86375 8.74214C4.74955 8.68302 4.62079 8.65277 4.49021 8.65436C4.35964 8.65595 4.23177 8.68933 4.11926 8.7512C4.00675 8.81308 3.9135 8.9013 3.84874 9.00713C3.78397 9.11297 3.74994 9.23276 3.75 9.35464V19.4195C3.74994 19.5444 3.78572 19.6672 3.85364 19.7749C3.92157 19.8826 4.01915 19.9714 4.13625 20.032L13.8863 25.0871C14.0005 25.1462 14.1292 25.1765 14.2598 25.1749C14.3904 25.1733 14.5182 25.1399 14.6307 25.0781C14.7432 25.0162 14.8365 24.928 14.9013 24.8221C14.966 24.7163 15.0001 24.5965 15 24.4746V14.4098C14.9998 14.285 14.9639 14.1625 14.896 14.0551C14.8281 13.9476 14.7307 13.859 14.6138 13.7985Z"
                fill="#F7D046" stroke="#061B3A" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="d-flex gap-3 align-items-center d-none d-lg-flex d-md-flex TopMenuHolder" style="flex: 1">
          <topMenu/>
        </div>
        <div class="d-flex gap-3 align-items-center PriceCloseHolder">
          <div class="d-flex align-items-center" @click="activateTopMenu('ProductSummery')">
            <div class="TotalPrice">
              <ICountUp :delay="delay" :endVal="endVal" :options="options" @ready="onReady"/>
            </div>
            <div class="valuta"> {{ $t('valuta') }}
              <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.8399 1.52344L7.16215 6.63344L1.48438 1.52344" stroke="#6F6F6F" stroke-width="1.70333"/>
              </svg>
            </div>
          </div>
          <div class="" id="ClosePrefabModal" aria-label="Close" style="cursor: pointer" @click="resetByggOnline()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="24" height="24" rx="12" fill="#F3F3F3"></rect>
              <path d="M15.375 8.625L8.625 15.375" stroke="#0A1D29" stroke-width="1.5" stroke-linecap="square"></path>
              <path d="M15.375 15.375L8.625 8.625" stroke="#0A1D29" stroke-width="1.5" stroke-linecap="square"></path>
            </svg>

          </div>
        </div>
      </div>

    </div>
    <div class="PrefabCreator_holder" style="flex: 1">

      <div class="tab-content">
        <div class="prefab-tap-pane  flex-column" id="ProductChooser" v-if="activeTab === 'ProductChooser'"
             style="padding: 20px">

          <div
              style="display: flex; flex-direction: column;" class="d-flex flex-column flex-grow-1">
            <SelectorsBtns v-if="$store.state.order.rows.length > 0"/>
          </div>
        </div>
      </div>

    </div>

    <Footer v-if="this.$store.state.view !== 'kassa' && $store.getters.CurrentCategoryIndex < ($store.getters.SubCategories.length -1 )"/>
    <div id="ProductSummery" class="prefab-tap-pane flex-column"
         v-if="activeTab === 'ProductSummery'">
      <div class="position-relative h-100">
        <resultat class="h-100"/>
      </div>
    </div>
    <div id="InfoWindow">
      <infoWindow v-if="Object.keys(this.$store.state.infoArticle).length > 0"/>
    </div>
  </div>
</template>

<script>
import topMenu from "@/components/topMenu";
import CurrentCategory from "@/components/CurrentCategory";
import SelectorsBtns from "@/components/SelectorsBtns";
import Footer from "@/components/Footer";
import resultat from "@/components/Summary";
import kassa from "@/components/Kassa";
import infoWindow from "@/components/InfoWindow";
import helpers from "@/helpers";
import ICountUp from "vue-countup-v2";

export default {
  name: 'App',

  data() {
    return {
      helpers,
      delay: 500,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: " ",
        decimal: ".",
        prefix: "",
        suffix: ""
      }

    }
  },
  watch: {
    endVal(n) {
      let i = document.getElementById('TotalPriceHolderTop')
      //  i.classList.add('animatePulse')
      setTimeout(function () {
        //   i.classList.remove('animatePulse')
      }, 1000)
    }

  },
  computed: {
    endVal() {
      return this.$store.getters.totalPrice
    },
    currentCategory() {
      return this.$store.state.CurrentCategory
    },
    activeTab() {
      return this.$store.state.activeTab
    }
  },
  components: {
    topMenu, CurrentCategory, SelectorsBtns, Footer, resultat, kassa, infoWindow, ICountUp
  },
  methods: {
    onClickOutsideHandler(e){
      console.log('aa',e)
   //this.resetByggOnline()
    },
    onReady: function (instance) {
      const that = this;
      instance.update(that.endVal);
    },

    showallOptions() {
      this.$store.commit('commit_showallOptions')
    },
    resetByggOnline() {
      this.$store.commit('commit_activeTab', 'ProductChooser')
      this.$store.commit('commit_current_view', '14')
      this.$store.commit('setup_first', this.$store.state.layers)
    },
    activateTopMenu(e, a) {
      if (this.$store.state.activeTab === e) {
        this.$store.commit('commit_activeTab', 'ProductChooser')
      } else {
        this.$store.commit('commit_activeTab', e)
      }

    },
    switchLocale() {
      let locale = window.myLang !== undefined ? window.myLang : 'swe'
      this.$i18n.locale = locale; // Change the current locale
    },
  },
  mounted() {
    this.$store.dispatch('initHouse'),
    this.switchLocale()

   /* var url = window.location.href; // replace this with your actual URL
    var urlParts = url.split('/');
    console.log('urlParts', urlParts)
    setTimeout(function () {
      if (urlParts.length > 0) {
        Array.from(urlParts).forEach(x => {
          console.log('x-urlParts', x)
          if (x === 'da') {
            console.log('x-da', x)
            Weglot.switchTo('da')
          } else {
            console.log('x-sv', x)
            Weglot.switchTo('sv')
          }

        })
      }
    }, 5000)*/


  }
}
</script>

<style lang="scss" scoped>
.animatePulse {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

#PrefabCreator {
  max-width: 878px;
  position: relative;
  height: 100%;
  min-height: calc(100vh);
  display: flex;
  flex-direction: column;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */

  #ProductSummery {
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    transform: translateX(0px);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.13);
    -webkit-transition: 0.25s transform ease-in-out;
    background-color: #FBFBFB;
    border-left: 1px solid var(--gray-05, #E8E8E8);
    z-index: 9999999;

  }


  .PriceCloseHolder {
    margin-top: 6px;
    flex: 1;
    justify-content: end;
  }

  .TopMenuHolder {
    margin-top: 6px;
  }

  .PCHeader {
    padding: 14px 20px 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 9;
    box-shadow: 2px 6px 11px rgba(0, 0, 0, .05), 0 1px 0px rgba(0, 0, 0, .04);
  }

  .PCHeader_nav {
    display: flex;
    flex-direction: row;
    gap: 30px;
    align-items: center;

    .valuta {
      font-size: 18px;
      margin-bottom: 0;
      font-weight: 600 !important;
      cursor: pointer;
      font-family: "futura-pt", sans-serif !important;
      font-style: normal;
      letter-spacing: 0.1px;
      text-align: left;
      display: flex;
      align-items: center;
      gap: 5px;

    }

    .TotalPrice {
      font-size: 18px;
      margin-bottom: 0;
      font-weight: 600 !important;
      cursor: pointer;
      font-family: "futura-pt", sans-serif !important;
      font-style: normal;
      letter-spacing: 0.1px;
      min-width: 70px;
      text-align: left;
      width: 70px;

      span {
        font-size: 18px;
        margin-bottom: 0;
        font-weight: 600 !important;
        cursor: pointer;
        font-family: "futura-pt", sans-serif !important;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }
}

_PrefabCreator {
  min-height: 400px;
  // max-height: 650px;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0 !important;
  overflow: hidden;

  .topMenu_clean {
    display: flex;
    justify-content: center;
    text-align: center;
    border-top: 1px solid #E8E8E8;

    & > div {
      color: rgba(111, 111, 111, 1);
      background-color: #F5F5F5;
      padding: 16px 10px;
      font-size: 14px;
      flex: 1;
      cursor: pointer;

      &.active {
        background-color: white !important;
        border-bottom: 2px solid var(--base-blue, #294F8A);
        color: #000;
        font-weight: 500;
      }

      &:hover {
        background-color: #F5F5F5;
        color: #000;
        font-weight: 500;
      }

    }
  }

  .btnVal {
    color: var(--gray-black, #000);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    border-radius: 14px;
    border: 1px solid var(--gray-11, #6F6F6F);
    background: var(--gray-white, #FFF);
    display: inline-flex;
    padding: 3px 9px;

    &:hover {
      background: #F5F5F5;
    }

  }
}

</style>
